/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type SequenceItem = {
  /**
   * Name of the sequence item
   */
  name: string;
  /**
   * Stage values of the sequence item
   */
  stageValues: Array<number>;
};

/** @internal */
export const SequenceItem$inboundSchema: z.ZodType<
  SequenceItem,
  z.ZodTypeDef,
  unknown
> = z.object({
  name: types.string(),
  stage_values: z.array(types.number()),
}).transform((v) => {
  return remap$(v, {
    "stage_values": "stageValues",
  });
});
/** @internal */
export type SequenceItem$Outbound = {
  name: string;
  stage_values: Array<number>;
};

/** @internal */
export const SequenceItem$outboundSchema: z.ZodType<
  SequenceItem$Outbound,
  z.ZodTypeDef,
  SequenceItem
> = z.object({
  name: z.string(),
  stageValues: z.array(z.number().int()),
}).transform((v) => {
  return remap$(v, {
    stageValues: "stage_values",
  });
});

export function sequenceItemToJSON(sequenceItem: SequenceItem): string {
  return JSON.stringify(SequenceItem$outboundSchema.parse(sequenceItem));
}
export function sequenceItemFromJSON(
  jsonString: string,
): SafeParseResult<SequenceItem, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SequenceItem$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SequenceItem' from JSON`,
  );
}
